import PropTypes from 'prop-types';
import { createContext, useState, useEffect } from 'react';
import useAuth from 'src/hooks/useAuth';
// hooks
// import useResponsive from '../hooks/useResponsive';

// ----------------------------------------------------------------------

const initialState = {
  collapseClick: false,
  collapseHover: false,
  onToggleCollapse: () => {},
  onHoverEnter: () => {},
  onHoverLeave: () => {},
  isCollapseSearchBar: false,
  onToggleCollapseSearchBar: () => {},
};

const CollapseDrawerContext = createContext(initialState);

// ----------------------------------------------------------------------

CollapseDrawerProvider.propTypes = {
  children: PropTypes.node,
};

function CollapseDrawerProvider({ children }) {
  // const isDesktop = useResponsive('up', 'lg');
  const { user, isAuthenticated } = useAuth();

  const [collapse, setCollapse] = useState({
    click: false,
    hover: false,
  });

  const [collapseSearchBar, setCollapseSearchBar] = useState(false);

  useEffect(() => {
    if(user && isAuthenticated){
      setCollapse({
        click: true,
        hover: false,
      });
    }
  }, [user,isAuthenticated]);

  const handleToggleCollapse = () => {
    setCollapse({ ...collapse, click: !collapse.click });
  };

  const handleHoverEnter = () => {
    if (collapse.click) {
      setCollapse({ ...collapse, hover: true });
    }
  };

  const handleHoverLeave = () => {
    setCollapse({ ...collapse, hover: false });
  };

  const handleToggleSearchBar = () => {
    setCollapseSearchBar(!collapseSearchBar);
  };

  return (
    <CollapseDrawerContext.Provider
      value={{
        isCollapse: collapse.click && !collapse.hover,
        collapseClick: collapse.click,
        collapseHover: collapse.hover,
        onToggleCollapse: handleToggleCollapse,
        onHoverEnter: handleHoverEnter,
        onHoverLeave: handleHoverLeave,
        isCollapseSearchBar: collapseSearchBar,
        onToggleCollapseSearchBar: handleToggleSearchBar
      }}
    >
      {children}
    </CollapseDrawerContext.Provider>
  );
}

export { CollapseDrawerProvider, CollapseDrawerContext };
